__turbopack_context__.v({
  "mark": "slider-module__5X84Za__mark",
  "marks": "slider-module__5X84Za__marks",
  "output": "slider-module__5X84Za__output",
  "range": "slider-module__5X84Za__range",
  "secondary": "slider-module__5X84Za__secondary",
  "wrapper": "slider-module__5X84Za__wrapper",
});
